module.exports = {
	link: "https://coinsup.in",
	  name: "Coinsup",
};
